module.exports = __webpack_public_path__ + "img/plan_name_grey_border.ebf978cd.svg";